import { useMemo } from 'react';

import { useCurrentUserAsync } from '#src/app/shared/hooks/session';
import type { SignPetitionHookInput } from '#src/app/shared/hooks/signature';
import { isLoaded } from '#src/app/shared/utils/async';

type Result = Pick<SignPetitionHookInput, 'userId'>;

export function useCurrentUserSignData(): Result {
	const currentUser = useCurrentUserAsync();

	return useMemo(
		() => ({
			userId: isLoaded(currentUser) && currentUser.value ? currentUser.value.id : null,
		}),
		[currentUser],
	);
}
